<template>
  <div class="product" :class="{ show }">
    <div class="inner">
      <div class="content">
        <img class="img" :src="product.image" />
        <div class="middle">
          <p class="title">{{ product.name }}</p>
          <p class="price-amount">
            <TweenPrice :price="amount" :with-format="false" />x
            <TweenPrice :price="vatPrice(priceEach / 100)" />/s
          </p>
          <p
            v-if="product.delivery_time"
            class="delivery-time"
            :class="{ warning: !hasOneDayDeliveryTime }"
          >
            {{ $t('global.word.delivery_time') + ' ' + product.delivery_time }}
          </p>
        </div>
      </div>
      <div>
        <div class="oldPrice" v-if="hasDiscount">
          <TweenPrice :price="vatPrice(priceOriginal)" />
        </div>
        <div class="total">
          <TweenPrice :price="vatPrice(priceWithDiscount)" />
        </div>
      </div>
    </div>

    <ProductAmount
      @increase="updateProductAmount(amount + 1)"
      @decrease="updateProductAmount(amount - 1)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ProductAmount from '../utilities/InputAmountButtons';
import TweenPrice from '../utilities/TweenPrice';

export default {
  name: 'OrderSummaryCategoryProduct',
  components: {
    TweenPrice,
    ProductAmount,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    room: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      show: 'getChangeAmountEnabled',
      calculateTotalPriceWithDiscount:
        'discount/calculateTotalPriceWithDiscount',
    }),
    ...mapGetters('build', ['getProductsForRoom']),
    productsForRoom() {
      return this.getProductsForRoom(this.room);
    },

    buildProduct() {
      return this.productsForRoom.find(
        (buildProduct) => buildProduct.id === this.product.category_product_id
      );
    },

    hasDiscount() {
      return (
        this.calculateTotalPriceWithDiscount(this.product.eans) !==
        this.calculateTotalPrice(this.product.eans)
      );
    },

    amount() {
      return this.buildProduct ? this.buildProduct.amount : 0;
    },

    priceEach() {
      return this.product.eans.reduce((total, ean) => {
        return total + ean.price;
      }, 0);
    },

    priceOriginal() {
      return (this.amount * this.priceEach) / 100;
    },

    priceWithDiscount() {
      return (
        (this.amount *
          this.calculateTotalPriceWithDiscount(this.product.eans)) /
        100
      );
    },

    hasOneDayDeliveryTime() {
      return (
        typeof this.product.delivery_time === 'string' &&
        this.product.delivery_time.includes('1 werkdag')
      );
    },
  },
  methods: {
    calculateTotalPrice(eans) {
      return eans.reduce((total, ean) => {
        return total + ean.price;
      }, 0);
    },

    async updateProductAmount(amount) {
      if (amount === 0) {
        this.$store.commit('order/removeProductById', {
          roomId: this.room,
          productId: this.product.id,
        });
      }

      await this.$store.dispatch('build/updateProduct', {
        id: this.buildProduct.id,
        roomId: this.room,
        amount,
      });
    },
  },
};
</script>
